import StyledWrapper from "@insite/client-framework/Common/StyledWrapper";
import WidgetModule from "@insite/client-framework/Types/WidgetModule";
import WidgetProps from "@insite/client-framework/Types/WidgetProps";
import Icon from "@insite/mobius/Icon";
import InjectableCss from "@insite/mobius/utilities/InjectableCss";
import EllipsisVerticalIcon from "@tCentro/Icons/EllipsisVerticalIcon";
import { COLORS } from "@tCentro/theme/design";
import React, { FC } from "react";
import { css } from "styled-components";

interface OwnProps extends WidgetProps {
    extendedStyles?: EllipsesContainerStyles;
}

export interface EllipsesContainerStyles {
    ellipsisVerticalIconWrapper?: InjectableCss;
    ellipsisIconWrapper?: InjectableCss;
}

export const ellipsesContainerStyles: EllipsesContainerStyles = {
    ellipsisIconWrapper: {
        css: css`
            width: 15%;
            display: flex;
            justify-content: flex-end;
        `,
    },
    ellipsisVerticalIconWrapper:{
        css:css`
            display: flex;
            align-items: center;
            justify-content: center;
            background: ${COLORS.white};
            border: 2px solid ${COLORS.background.grayShade};
            position: absolute;
            top: 120px;
            right: 16px;
            width: 48px;
            height: 48px;
            border-radius: 40px;
            
        `
    }
};

const styles = ellipsesContainerStyles;

const EllipsesContainer: FC<OwnProps> = ({ id }) => {
    return (
        <StyledWrapper {...styles.ellipsisIconWrapper}>
            <StyledWrapper {...styles.ellipsisVerticalIconWrapper}>
                <Icon src={EllipsisVerticalIcon} />
            </StyledWrapper>
        </StyledWrapper>
    );
};

const ellipsesContainer: WidgetModule = {
    component: EllipsesContainer,
    definition: {
        group: "Product Details",
    },
};

export default ellipsesContainer;
